let _cognitoToken = null;
let _resolveTokenReady;
let _cognitoTokenReady = null;

const isValidJwt = token =>
  typeof token === "string" &&
  /^[A-Za-z0-9_-]+\.[A-Za-z0-9_-]+\.[A-Za-z0-9_-]+$/.test(token) &&
  token.length < 2048;

// Called once when running inside a PHQ iframe. Subsequent API requests will
// await the returned promise before sending so that the Cognito header is
// always present. Resolves after the first valid token is received or after
// timeoutMs (so requests are never permanently blocked if the message is lost).
export const initTokenReadyPromise = (timeoutMs = 5000) => {
  if (_cognitoToken) {
    _cognitoTokenReady = Promise.resolve();
    return;
  }
  _cognitoTokenReady = new Promise(resolve => {
    _resolveTokenReady = resolve;
    setTimeout(resolve, timeoutMs);
  });
};

export const setCognitoToken = token => {
  if (isValidJwt(token)) {
    _cognitoToken = token;
    if (_resolveTokenReady) {
      const resolver = _resolveTokenReady;
      _resolveTokenReady = null;
      resolver();
    }
  }
};
export const getCognitoToken = () => _cognitoToken;
// Resolves immediately when not iframed (null promise), or when the token arrives.
export const tokenReady = () => _cognitoTokenReady ?? Promise.resolve();
